import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getAllLeadDestinationTypesAsync = createAsyncThunk(
    "leadDestinations/getAllLeadDestinationTypes",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/get-destination-types`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getAllLeadDestinationsAsync = createAsyncThunk(
    "leadDestinations/getAllLeadDestinations",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/destinations`,
            RequestConfig(),
        );
        return response.data;
    },
);
